<template>
  <router-link :to="`/referral/${item.id}?level=${level}`" class="flex items-center justify-between">
    <div class="flex items-center">
      <div>
        <div class="w-10 h-10 rounded-full flex items-center justify-center m-yellow-bg">
          {{ item.user ? item.user.name[0] : '?' }}
        </div>
      </div>
      <div class="pl-3">
        {{ item.user ? item.user.name : '' }} ({{ item.user.ref_count }})
        <template v-if="item.total_completed_amount">
          <span :class="['m-green-color ml-2']">+{{ formattedAmount(item.total_completed_amount) }}</span>
        </template>

        <div class="text-sm" :class="[item.user.app_status === 'completed' ? $theme.successPnlColor : 'opacity-50']">
          {{ $t(item.user.app_status.toLowerCase()) }}
        </div>
      </div>
    </div>
    <div class="flex items-center flex-col">
      <div>
        <ArrowUpIcon class="w-5" :class="[$theme.IconSvgColor]" />
      </div>
    </div>
  </router-link>
</template>

<script>
import {formattedAmount} from '@/helpers/numberHelper';
import ArrowUpIcon from "@/assets/icons/ArrowUpIcon.vue";

export default {
  methods: {
  },
  props: [
    'item',
    'level',
  ],

  components: {
    ArrowUpIcon,
  },

  data() {
    return {
      formattedAmount
    }
  }
}
</script>